import React, { useContext } from 'react'
import { Cell, Row } from '../../fragments/comp/grid'
import { CartCharge } from '../../model-order'

import { useEditOrderSvc, useRestaurantFromOrder } from '../service'
import Icon from 'react-fa'
import { ActionEditor, ActionEditorKind } from '../model'
import { Restaurant, RestaurantCtx } from '../../model-restaurant'

export function DetailedCharges(props: { openEditor: (actionEditor: ActionEditor) => void }): JSX.Element {
  const editOrderSvc = useEditOrderSvc()
  const cartCharges = editOrderSvc.getCartCharges()

  return (
    <>
      {cartCharges.map((c: CartCharge) => (
        <HCartCharge
          key={`${c.id}-${editOrderSvc.getChangesCount()}`}
          charge={c}
          allCharges={cartCharges}
          level={1}
          openEditor={props.openEditor}
        />
      ))}
    </>
  )
}

const DeleteChargeButton = (props: {
  currentCharge: CartCharge
  openEditor: (actionEditor: ActionEditor) => void
}): JSX.Element => {
  const editOrderSvc = useEditOrderSvc()
  if (
    props.currentCharge.adjustments ||
    props.currentCharge.type == 'menu_markup' ||
    props.currentCharge.type == 'convenience_fee'
  ) {
    return <></>
  }
  return (
    <div
      className="badge badge-danger"
      style={{ cursor: 'pointer' }}
      title={'Remove charge'}
      onClick={() =>
        confirm(`Are you sure you want to remove ${props.currentCharge.name} charge from the order?`) &&
        props.currentCharge.action
          ? editOrderSvc.discardAction(props.currentCharge.action)
          : editOrderSvc.recordChange({
              op: 'remove-charge',
              charge_name: props.currentCharge.name,
              charge_id: props.currentCharge.id,
            })
      }>
      <Icon name="remove" />
    </div>
  )
}

const EditChargeButton = (props: {
  currentCharge: CartCharge
  openEditor: (actionEditor: ActionEditor) => void
}): JSX.Element => {
  if (
    props.currentCharge.adjustments ||
    props.currentCharge.type == 'menu_markup' ||
    props.currentCharge.type == 'convenience_fee'
  ) {
    return <></>
  }
  return (
    <div
      className="badge badge-warning"
      style={{ cursor: 'pointer' }}
      title={'Edit charge'}
      onClick={() => props.openEditor({ kind: ActionEditorKind.EditCharge, chargeId: props.currentCharge.id })}>
      <Icon name="edit" />
    </div>
  )
}

import * as utils from '../../../components/utils'

function HCartCharge(props: {
  charge: CartCharge
  allCharges: CartCharge[]
  openEditor: (actionEditor: ActionEditor) => void
  level: number
}): JSX.Element {
  const editOrderSvc = useEditOrderSvc()
  const restaurantSvc = useContext(RestaurantCtx) as Restaurant
  const isRemoved = props.charge.adjustments && props.charge.adjustments.find((x) => (x.amount = -props.charge.amount)) //[0].amount == -props.charge.amount
  console.log('Render HCartCharge', props.charge, props.level)
  return (
    <>
      {props.charge.amount > 0 && (
        <Row>
          <Cell>
            <span
              style={{
                marginLeft: `${20}px`,
                color: 'ThreeDShadow',
                textDecoration: isRemoved ? 'line-through' : 'none',
              }}>
              {props.charge.name}
            </span>
          </Cell>
          <Cell align="right">
            <EditChargeButton currentCharge={props.charge} openEditor={props.openEditor} />
            <span style={{ textDecoration: isRemoved ? 'line-through' : 'none' }}>
              {' '}
              {utils.currency(restaurantSvc.locale, props.charge.amount * 100)}{' '}
            </span>
            <DeleteChargeButton currentCharge={props.charge} openEditor={props.openEditor} />
          </Cell>
        </Row>
      )}
      {props.charge.adjustments &&
        props.charge.adjustments.map((c) => (
          <HCartCharge
            key={`${c.id}-${editOrderSvc.getChangesCount()}`}
            charge={c}
            allCharges={props.allCharges}
            openEditor={props.openEditor}
            level={props.level + 1}
          />
        ))}
    </>
  )
}
